import React, { Component } from "react";
import queryString from "query-string";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TeslaIcon from "../../icons/TeslaIcon";
import { Input } from "reactstrap";
import RDSRadioButton from "../../components/common/RDSRadioButton";
import RDSButton from "../../components/common/RDSButton";
import RdsBackIcon from "../../icons/RdsBackIcon";
import CheckboxIcon from "../../icons/CheckboxIcon";
import ErrorIcon from "../../icons/ErrorIcon";
import XIcon from "../../icons/XIcon";
import WarningIcon from "../../icons/WarningIcon";
import Loading from "../../components/common/LoadingIndicator";
import StoreStateConstants from "../../constants/store/StoreStateConstants";
import * as imgActionCreator from "../../actions/imgActionCreator";
import * as orderActionCreator from "../../actions/orderActionCreator";
import * as translationActionCreator from "../../actions/translationActionCreator";
import * as globalAlertActionCreator from "../../actions/globalAlertActionCreator";

import ProofOfAddressIntro from "../../images/proof_of_address_intro.jpg";
import ProofOfAddressDemo from "../../images/proof_of_address_demo.jpg";
import LocalStorageUtil from "../../utils/LocalStorageUtil";
import IDCard from "../../images/card.gif";
import PagePathConstants from "../../constants/router/PagePathConstants";
import { BASE_URL } from "../../constants/api/ApiEndpointConstants";
import tracker from "../../tracker";
import { sendCustomEvent } from "../../apis/ConfigAPI";

class ProofOfAddressPage extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			identity_types: this.renderIdentityTypes(),
			selectedProofAddressType: StoreStateConstants.PROOF_ADDRESS_TYPE_BANK,
			showLoading: false,
			addressProofDocument: "",
			documentBack: "",
			showOnboardingGif: true,
			isShowVerificationFailedModal: false,
			showSecondaryBrandIcon: false,
		};
		this.handleSelectIdType = this.handleSelectIdType.bind(this);
		this.handleSelectFile = this.handleSelectFile.bind(this);
		this.toggleLoading = this.toggleLoading.bind(this);
		this.handleSubmitForm = this.handleSubmitForm.bind(this);
		this.goBack = this.goBack.bind(this);
		this.toggleOnboarding = this.toggleOnboarding.bind(this);
		this.renderIdentityTypes = this.renderIdentityTypes.bind(this);
		this.prefillOrderParams = this.prefillOrderParams.bind(this);
		this.checkInfoToSubmit = this.checkInfoToSubmit.bind(this);
		this.toggleVerificationFailedModal = this.toggleVerificationFailedModal.bind(this);
	}

	componentDidMount() {
		const orderData = LocalStorageUtil.loadOrderDetail();
		const { firstName, email, snCode, country } = orderData;
		if (!firstName || firstName?.trim() === "" || !email || email?.trim() === "" || ((country === "US" || country === "GB") && !snCode) || snCode?.trim() === "") {
			const { history, location } = this.props;
			history.replace({ pathname: PagePathConstants.CUSTOM_INFO, search: location.search });
			return;
		}
		this.prefillOrderParams();
	}

	prefillOrderParams() {
		const orderInfo = LocalStorageUtil.loadOrderDetail();
		this.setState({
			selectedProofAddressType: orderInfo.proofAdressType ? orderInfo.proofAdressType : this.state.selectedProofAddressType,
			addressProofDocument: orderInfo.addressProofDocument ? orderInfo.addressProofDocument : this.state.addressProofDocument,
		});
	}

	renderIdentityTypes() {
		return [
			{
				name: StoreStateConstants.PROOF_ADDRESS_TYPE_BANK,
				label: "Bank Statement",
			},
			{
				name: StoreStateConstants.PROOF_ADDRESS_TYPE_GAS,
				label: "Gas Bill",
			},
			{
				name: StoreStateConstants.PROOF_ADDRESS_TYPE_UTILITY,
				label: "Utility Bill",
			},
			{
				name: StoreStateConstants.PROOF_ADDRESS_TYPE_PHONE,
				label: "Phone Bill",
			},
		];
	}

	toggleOnboarding() {
		this.setState({ showOnboardingGif: !this.state.showOnboardingGif });
	}

	goBack() {
		const { history } = this.props;
		history && history.goBack();
	}

	handleSelectIdType(name) {
		this.setState({ selectedProofAddressType: name });
	}

	handleSelectFile(e, isDocumentFront) {
		e.preventDefault();
		e && e.stopPropagation();

		const orderData = LocalStorageUtil.loadOrderDetail();

		const { imgActions } = this.props;
		const _this = this;
		[...e.target.files].forEach((fileInfo, index) => {
			if (index > 0) return;
			let reads = new FileReader();
			reads.readAsDataURL(fileInfo);
			reads.onload = function (e) {
				const imgUrl = this.result;
				_this.toggleLoading();
				imgActions &&
					imgActions
						.uploadImgToGetUrl({ snCode: orderData && orderData.snCode, img: imgUrl })
						.then((url) => {
							_this.toggleLoading();
							if (isDocumentFront) {
								let cachedAddressProofNum = localStorage.getItem("cachedAddressProofNum");
								if (!cachedAddressProofNum) {
									cachedAddressProofNum = 0;
								}
								cachedAddressProofNum = parseInt(cachedAddressProofNum) + 1;
								localStorage.setItem("cachedAddressProofNum", cachedAddressProofNum.toString());
								_this.setState({ addressProofDocument: url }, _this.checkInfoToSubmit);
							} else {
								let cachedDocumentBackNum = localStorage.getItem("cachedDocumentBackNum");
								if (!cachedDocumentBackNum) {
									cachedDocumentBackNum = 0;
								}
								cachedDocumentBackNum = parseInt(cachedDocumentBackNum) + 1;
								localStorage.setItem("cachedDocumentBackNum", cachedDocumentBackNum.toString());
								_this.setState({ documentBack: url }, _this.checkInfoToSubmit);
							}
							e.target.value = "";
						})
						.catch((err) => {
							_this.toggleLoading();
							e.target.value = "";
						});
			};
		});
	}

	checkInfoToSubmit() {
		const { orderActions, location } = this.props;
		const orderInfo = LocalStorageUtil.loadOrderDetail();

		if (orderInfo) {
			// const { firstName, lastName, email, phone, driveEmail, drivePhone, state, city, country, address, zipCode, vehicleModel, snCode } = orderInfo;
			const { addressProofDocument, selectedProofAddressType } = this.state;

			const queryParams = queryString.parse(location.search);
			let ad = "test";
			const localAd = LocalStorageUtil.loadFbAdParams();
			if (localAd && localAd.trim() !== "") {
				ad = localAd;
			}
			if (queryParams.ad && queryParams.ad !== "") {
				ad = queryParams.ad;
			}
			let data = {
				proofAdressType: selectedProofAddressType,
				id: "",
				orderNu: "",
				ad,
			};
			const orderId = LocalStorageUtil.loadOrderId();
			if (orderId && orderId !== "" && orderId !== "undefined") {
				data.id = orderId;
			}

			const orderNu = LocalStorageUtil.loadOrderNumber();
			if (orderNu && orderNu !== "" && orderNu !== "undefined") {
				data.orderNu = orderNu;
			}
			if (addressProofDocument && addressProofDocument.trim() !== "") {
				data["addressProofDocument"] = addressProofDocument;
			}
			if (queryParams.ad && queryParams.ad !== "") {
				data["ad"] = queryParams.ad;
			}

			let requestData = Object.assign({}, data);
			if (requestData.addressProofDocument && requestData.addressProofDocument.trim() !== "") {
				requestData.addressProofDocument = requestData.addressProofDocument.replace(BASE_URL, "");
			}
			if (requestData.documentBack && requestData.documentBack.trim() !== "") {
				requestData.documentBack = requestData.documentBack.replace(BASE_URL, "");
			}

			orderActions &&
				orderActions.updateDriverOrder(requestData).catch((err) => {
					if (err === "id duplication") {
						LocalStorageUtil.clearOrderId();
						LocalStorageUtil.clearOrderNumber();
					}
				});
		}
	}

	toggleLoading() {
		this.setState({ showLoading: !this.state.showLoading });
	}

	handleSubmitForm() {
		const { selectedProofAddressType, addressProofDocument } = this.state;

		const { location, orderActions, history } = this.props;

		const queryParams = queryString.parse(location.search);
		let ad = "test";
		const localAd = LocalStorageUtil.loadFbAdParams();
		if (localAd && localAd.trim() !== "") {
			ad = localAd;
		}
		if (queryParams.ad && queryParams.ad !== "") {
			ad = queryParams.ad;
		}

		let data = {
			proofAdressType: selectedProofAddressType,
			addressProofDocument,
			id: "",
			orderNu: "",
			ad,
		};

		const orderId = LocalStorageUtil.loadOrderId();
		if (orderId && orderId !== "" && orderId !== "undefined") {
			data.id = orderId;
		}

		const orderNu = LocalStorageUtil.loadOrderNumber();
		if (orderNu && orderNu !== "" && orderNu !== "undefined") {
			data.orderNu = orderNu;
		}

		let orderData = LocalStorageUtil.loadOrderDetail();
		tracker.trackIdentificationPhoto(`${orderData.firstName} ${orderData.lastName}`);
		sendCustomEvent("AddAddressProofInformation");
		LocalStorageUtil.saveOrderDetail(data);

		this.toggleLoading();
		orderActions &&
			orderActions
				.updateDriverOrder(data)
				.then((order) => {
					this.toggleLoading();

					order.id && order.id !== 0 && LocalStorageUtil.saveOrderId(order.id);
					order.orderNu && order.orderNu !== 0 && LocalStorageUtil.saveOrderNumber(order.orderNu);
					const cachedAddressProofNum = localStorage.getItem("cachedAddressProofNum");

					if (cachedAddressProofNum < 2) {
						this.toggleVerificationFailedModal();
						if (selectedProofAddressType !== StoreStateConstants.IDENTITY_TYPE_PASSPORT) {
							this.setState({
								addressProofDocument: cachedAddressProofNum < 2 ? "" : this.state.addressProofDocument,
							});
						} else {
							this.setState({ addressProofDocument: "" });
						}
					} else {
						history && history.push({ pathname: PagePathConstants.ORDER_CONFIRM, search: location.search });
					}
				})
				.catch((err) => {
					if (err === "id duplication") {
						LocalStorageUtil.clearOrderId();
						LocalStorageUtil.clearOrderNumber();
					}
					this.toggleLoading();
				});
	}

	toggleVerificationFailedModal() {
		this.setState({ isShowVerificationFailedModal: !this.state.isShowVerificationFailedModal });
	}

	handleScroll() {
		const scrollTop = this.scrollContainerRef && this.scrollContainerRef.current.scrollTop;
		this.setState({ showSecondaryBrandIcon: scrollTop >= 50 });
	}

	render() {
		const { showError, errorMsg, showLoading, selectedProofAddressType, addressProofDocument, showOnboardingGif, isShowVerificationFailedModal } = this.state;
		const disabledSubmitBtn = selectedProofAddressType.trim() === "" || addressProofDocument.trim() === "";
		return (
			<div className="tw-w-full tw-h-full gotham-font tw-text-[#393c41] ">
				{showLoading && <Loading />}
				{isShowVerificationFailedModal && (
					<div className="tw-w-full tw-h-full tw-fixed tw-top-0 tw-absolute tw-left-0 tw-bg-[rgba(0,0,0,0.5)] tw-flex tw-justify-center tw-items-center tw-z-[10000]" onClick={this.toggleVerificationFailedModal}>
						<div className="tw-w-[330px] tw-px-[10px] tw-pt-[30px] tw-py-[10px] tw-relative tw-overflow-hidden tw-rounded-[10px] tw-bg-white" onClick={(e) => e.stopPropagation()}>
							<XIcon onClick={this.toggleVerificationFailedModal} className="tw-absolute tw-right-[10px] tw-top-[6px]" size={26} />
							<img src={ProofOfAddressIntro} alt="tip" className="tw-w-[300px] tw-h-auto tw-mx-auto tw-z-[1000px] " />
							<div className="tw-text-[16px] tw-pb-[10px] tw-px-[20px] tw-bg-white tw-font-bold tw-text-center tw-text-[#c00]">Address validation failed!</div>
							<div className="tw-mt-[6px] tw-text-[14px] tw-pb-[20px] tw-px-[10px] tw-bg-white tw-rounded-bl-[10px] tw-rounded-br-[10px] tw-text-center">
								<div className="tw-flex tw-flex-col tw-items-center tw-justify-start">
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center"><ErrorIcon size="20" className="tw-mr-[10px] tw-shrink-0" color="#c00"/>We do not accept screenshots.</div>
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center"><ErrorIcon size="20" className="tw-mr-[10px] tw-shrink-0" color="#c00"/>Make sure the edges of the document without obstructions.</div>
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center"><CheckboxIcon size="20" className="tw-mr-[10px] tw-shrink-0" color="#33A954"/>Ensure the documents are within <span className="tw-text-[#c00] tw-mx-[4px]">180</span> days.</div>
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center"><CheckboxIcon size="20" className="tw-mr-[10px] tw-shrink-0" color="#33A954"/>Make sure the text is legible.</div>
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center tw-text-[#c00]"><WarningIcon size="16" className="tw-ml-[2px] tw-mr-[12px] tw-shrink-0" color="#c00"/>Recommend you upload a PDF file.</div>
								</div>
							</div>
						</div>
					</div>
				)}
				<div className="tw-w-full tw-h-full phone:tw-h-full phone:tw-pb-[200px] tw-overflow-scroll">
					<div className="tw-z-[100] tw-w-full tw-h-[80px] tw-flex tw-justify-between tw-items-center">
						<div className="tw-w-1/3 tw-h-full tw-flex tw-items-center tw-pl-[30px]">
							<RdsBackIcon color="#171a20" onClick={this.goBack} />
						</div>
						<TeslaIcon size={150} color="#171a20" />
						<div className="tw-w-1/3"></div>
					</div>

					{showOnboardingGif ? (
						<div className="tw-w-full tw-text-center tw-flex tw-flex-col tw-items-center tw-px-[30px] animate__fadeIn animate__animated">
							<div className="tw-text-[32px] phone:tw-text-[26px] tw-font-bold">Proof of Address Check</div>
							<div className="tw-text-[20px] phone:tw-text-[16px] tw-mt-[10px]">Please upload a proof of address document (such as a bank statement, gas bill, utility bill, or phone bill) to verify your residence.</div>
							<div className="tw-mt-[50px] phone:tw-mt-0 tw-w-[660px] phone:tw-w-[calc(100%-40px)] tw-h-[495px] phone:tw-h-[400px]" style={{ backgroundImage: `url(${ProofOfAddressIntro})`, backgroundSize: "100%", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}></div>
							<div className="tw-w-full tw-flex tw-justify-center tw-items-center tw-mt-[0px] tw-text-white">
								<RDSButton rectangle className="tw-w-[80%] tw-rounded-[6px]" color="primary" onClick={this.toggleOnboarding}>
									<span>NEXT</span>
								</RDSButton>
							</div>
						</div>
					) : (
						<div className="tw-mt-[50px] tw-w-[660px] tw-mx-auto phone:tw-px-[20px] phone:tw-w-full phone:tw-mt-[10px] animate__slideInUp animate__animated">
							<div className="tw-w-full tw-mt-[10px]">
								<div className="tw-text-[#5c5e62] tw-font-[500] tw-text-[28px] phone:tw-text-[22px]">Choose your proof of address document</div>
								<span className="tw-text-[14px] tw-font-[500]">
									Please provide a proof of address from the <span className="tw-text-[#c00]">last 6 months</span>. We recommend uploading it in <span className="tw-text-[#c00]">PDF format</span>.
								</span>
								<div className="tw-mt-[10px]">
									{this.state.identity_types.map((item) => {
										return (
											<div className="tw-mt-[10px] tw-border-border-gray tw-border tw-px-[10px] tw-py-[10px] tw-mb-[10px] tw-rounded-[10px] tw-flex tw-items-center" key={item.name} onClick={() => this.handleSelectIdType(item.name)}>
												<RDSRadioButton name="grade-subject-selector" checked={item.name === selectedProofAddressType} id="grade-subject-radio" />
												<span className="tw-ml-[15px] tw-items-center tw-text-[14px] tw-font-[500]">{item.label}</span>
											</div>
										);
									})}
								</div>

								<div className="tw-flex phone:tw-flex-wrap tw-justify-between tw-items-start tw-mb-[30px]">
									<div className="tw-w-[50%] phone:tw-w-full  tw-h-[500px] tw-border tw-relative tw-overflow-hidden">
										<Input className="!tw-border-none tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-[500px] tw-opacity-0 tw-z-[101]" type="file" onChange={(e) => this.handleSelectFile(e, true)} accept="image/*,application/pdf" />
										{addressProofDocument !== "" && addressProofDocument.indexOf(".pdf") < 0 && <div className={`tw-w-full tw-border tw-h-[500px] tw-absolute tw-left-0 tw-top-0`} style={{ backgroundImage: `url(${addressProofDocument})`, backgroundPosition: "center", backgroundSize: "cover", backgroundRepeat: "no-repeat" }}></div>}
										{addressProofDocument !== "" && addressProofDocument.indexOf(".pdf") >= 0 && (
											<React.Fragment>
												<div className="tw-overflow-hidden">
													<iframe src={`${addressProofDocument}#toolbar=0`} width="100%" height="500" style={{ border: "none", overflow: "hidden" }}></iframe>
												</div>
											</React.Fragment>
										)}
										{addressProofDocument === "" && (<React.Fragment>
											<div className="tw-mx-auto phone:tw-mt-0 tw-w-[660px] tw-h-[500px] phone:tw-w-[calc(100%-40px)] tw-h-[495px] phone:tw-h-[400px]" style={{ backgroundImage: `url(${ProofOfAddressDemo})`, backgroundSize: "100%", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}></div>
											<div className="tw-text-center tw-text-body-text-grey tw-mt-[10px] tw-font-bold">Click to upload your proof of address</div>
										</React.Fragment>)}
									</div>
								</div>
							</div>

							{showError && <div className="tw-text-[#c00] tw-my-[30px] tw-px-[20px]">{errorMsg}</div>}
							<div className="tw-w-full tw-flex tw-justify-center tw-items-center tw-mt-[30px] tw-text-white tw-mt-[50px]">
								<RDSButton rectangle className="tw-w-[80%] tw-rounded-[6px]" color="primary" onClick={this.handleSubmitForm} disabled={disabledSubmitBtn}>
									<span>NEXT</span>
								</RDSButton>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {};
}

function mapDispatchToProps(dispatch) {
	return {
		imgActions: bindActionCreators(imgActionCreator, dispatch),
		orderActions: bindActionCreators(orderActionCreator, dispatch),
		translationActions: bindActionCreators(translationActionCreator, dispatch),
		globalAlertActions: bindActionCreators(globalAlertActionCreator, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ProofOfAddressPage);
